// The cart lives in localStorage between visits, which means another tab, an
// extension or a half written entry can leave something there that is not a
// cart at all. Every component reading it — the cart page, the header, the
// "Mám zájem" button — does so while Alpine is initialising, so a throw here
// takes the whole component with it: the customer is then looking at an empty
// cart, or at a button that does nothing, with no way to recover but clearing
// the site data.
export const CART_STORAGE_KEY = 'cart';

/**
 * The saved cart, or an empty one when there is nothing readable to show.
 *
 * @returns {Array<Object>}
 */
export const readStoredCart = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(CART_STORAGE_KEY));

    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
};

/**
 * Save the cart, so the header and the cart page agree on what is in it.
 *
 * @param {Array<Object>} cart
 */
export const writeStoredCart = (cart) => {
  localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
};
